(function (window, undefined) {
    const isProductPage = function() {
        return location.pathname.slice(0, 10) === '/products/' && location.pathname.length > 10;
    };

    const getProductJson = function() {
        try {
            return JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{}');
        } catch {
            return null;
        }
    };

    const getVariantSku = function(variantId) {
        const productJson = getProductJson();
        if (!productJson?.variants) return variantId;
        const variant = productJson.variants.find(v => v.id.toString() === variantId);
        return variant?.sku || variantId;
    };

    const getCartJson = async function() {
        try {
            const resp = await fetch(`${Shopify.routes.root}cart.js`);
            return await resp.json();
        } catch {
            return null;
        }
    };

    const getAcceleratedCheckoutSelectors = function() {
        return 'shopify-buy-it-now-button, shopify-paypal-button, more-payment-options-link, shop-pay-wallet-button, shopify-amazon-pay-button, shopify-google-pay-button';
    };

    const getAcceleratedCheckoutMethod = function(target) {
        const selectorMap = {
            'shopify-paypal-button': 'PayPal',
            'shop-pay-wallet-button': 'Shop Pay',
            'shopify-google-pay-button': 'Google Pay',
            'shopify-amazon-pay-button': 'Amazon Pay',
            'shopify-buy-it-now-button': 'Buy Now',
            'more-payment-options-link': 'More Payment Options'
        };
        for (const [selector, method] of Object.entries(selectorMap)) {
            if (target.closest(selector)) return method;
        }
        return '';
    };

    //提取URL中的utm参数
    const getUtmParams = function() {
        const params = new URLSearchParams(location.search);
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        const result = {};
        utmKeys.forEach(function(key) {
            const value = params.get(key);
            if (value) {
                result[key] = value;
            }
        });
        return result;
    };

    const productVideoPlayedKey = 'lashey_product_video_played';

    const gaGlobalVars = window.gaGlobalVars || {};
    const userId = gaGlobalVars.userId;
    const baseCfg = {
        page_location: location.href, // 当前页面URL
        page_path: location.pathname, //路由名,
        page_title: document.title, //页面标题,
        device_type: window.innerWidth >= 640 ? 'PC' : 'M',//来源终端
        user_id: userId, //用户标识（登录后统计）
        ...getUtmParams() //utm参数
    };


    const markProductVideoPlayed = function() {
        window.__lasheyProductVideoPlayed = true;

        try {
            sessionStorage.setItem(productVideoPlayedKey, '1');
        } catch {
            // sessionStorage may be unavailable in some embedded browsers.
        }
    };

    const hasProductVideoPlayed = function() {
        if (window.__lasheyProductVideoPlayed) return true;

        try {
            return sessionStorage.getItem(productVideoPlayedKey) === '1';
        } catch {
            return false;
        }
    };

    const getVideoIndex = function(slide) {
        if (!slide) return 0;

        const slideIndex = slide.getAttribute('data-swiper-slide-index');
        if (slideIndex !== null && slideIndex !== '') {
            return parseInt(slideIndex, 10) || 0;
        }

        return [...slide.parentNode?.children || []].indexOf(slide);
    };

    const getVideoProgressParams = function(video) {
        const totalLength = Number.isFinite(video?.duration) ? Math.round(video.duration) : 0;
        const playDuration = Number.isFinite(video?.currentTime) ? Math.round(video.currentTime) : 0;

        return {
            video_address: video?.currentSrc || video?.src || '',
            // total_length: totalLength,
            // play_duration: playDuration,
            // percent: totalLength ? Math.round((playDuration / totalLength) * 100) : 0
        };
    };

    const pushProductVideoEvent = function(eventName, eventAction, eventLabel, extraCfg = {}) {
        dataLayer.push({
            ...baseCfg,
            event: eventName,
            page_type: 'product_detail',
            event_action: eventAction,
            event_label: eventLabel,
            ...extraCfg
        });
    };

    const initProductVideoStatistics = function() {
        const videoSwiperEl = document.querySelector('.producVideoSwiper');
        const customerVideoSwiperEl = document.querySelector('.customerVideo');
        const videoModuleEls = [videoSwiperEl, customerVideoSwiperEl].filter(Boolean);
        let hasTrackedVideoModuleView = false;

        if (videoModuleEls.length && 'IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function(entries, instance) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting || hasTrackedVideoModuleView) return;

                    hasTrackedVideoModuleView = true;
                    pushProductVideoEvent(
                        'customer_check_video_reviews',
                        'view',
                        'product_detail_check_video_reviews'
                    );
                    instance.disconnect();
                });
            }, { threshold: 0.3 });

            videoModuleEls.forEach(function(videoModuleEl) {
                observer.observe(videoModuleEl);
            });
        } else if (videoModuleEls.length) {
            hasTrackedVideoModuleView = true;
            pushProductVideoEvent(
                'customer_check_video_reviews',
                'view',
                'product_detail_check_video_reviews'
            );
        }

        const bindSwiperEvents = function(swiperEl, retryCount = 0) {
            const swiper = swiperEl?.swiper;
            if (!swiper) {
                if (retryCount < 20) {
                    setTimeout(function() {
                        bindSwiperEvents(swiperEl, retryCount + 1);
                    }, 200);
                }
                return;
            }

            swiper.on('slideChange', function() {
                const activeSlide = swiper.slides[swiper.activeIndex];
                pushProductVideoEvent(
                    'customer_scroll_video_reviews',
                    'view',
                    'product_detail_scroll_video_reviews',
                    { video_index: getVideoIndex(activeSlide) }
                );
            });
        };

        if (videoModuleEls.length) {
            videoModuleEls.forEach(function(swiperEl) {
                bindSwiperEvents(swiperEl);
            });
        }

        document.addEventListener('click', function(evt) {
            const target = evt.target;
            const videoSlide = target.closest('.producVideoSwiper .swiper-slide');
            const customerVideoSlide = target.closest('.customerVideo .swiper-slide, .product-video-contain');

            if (target.closest('.producVideoSwiper .swiper-button-prev')) {
                const activeSlide = videoSwiperEl?.swiper?.slides?.[videoSwiperEl.swiper.activeIndex];
                pushProductVideoEvent(
                    'customer_click_pre',
                    'click',
                    'product_detail_click_video_reviews_pre',
                    { video_index: getVideoIndex(activeSlide) }
                );
                return;
            }

            if (target.closest('.producVideoSwiper .swiper-button-next')) {
                const activeSlide = videoSwiperEl?.swiper?.slides?.[videoSwiperEl.swiper.activeIndex];
                pushProductVideoEvent(
                    'customer_click_next',
                    'click',
                    'product_detail_click_video_reviews_next',
                    { video_index: getVideoIndex(activeSlide) }
                );
                return;
            }

            if (videoSlide && target.matches('.video-btn.video-stop')) {
                const video = videoSlide.querySelector('video');
                markProductVideoPlayed();
                pushProductVideoEvent(
                    'customer_click_video_play',
                    'view',
                    'product_detail_click_video_play',
                    getVideoProgressParams(video)
                );
                return;
            }

            if (
                customerVideoSlide
                && (
                    target.matches('.video-full')
                    || target.closest('.video-full')
                    || target.matches('.video-voice.video-stop')
                )
            ) {
                const video = customerVideoSlide.querySelector('video');
                markProductVideoPlayed();
                pushProductVideoEvent(
                    'customer_click_video_play',
                    'view',
                    'product_detail_click_video_play',
                    getVideoProgressParams(video)
                );
            }
        }, true);
    };

    if (isProductPage()) {
        document.addEventListener('DOMContentLoaded', initProductVideoStatistics);

        const productComponent = document.querySelector('product-component');
        productComponent?.addEventListener('click', function (evt) {
            const evtTarget = evt.target;
            const addToCartBtnSelector = 'button[data-add-to-cart]';
            const addToCartPopupBtnSelector = 'button[data-add-to-cart-bar]';
            let gaTarget, pushCfg;

            //点击加购按钮并加购成功
            if (gaTarget = evtTarget.matches(addToCartBtnSelector) ? evtTarget : evtTarget.closest(addToCartBtnSelector)) {
                const overlayCfg = {
                    event: "customer_add_to_cart", // 事件名称
                    page_type: "product_detail",
                    event_label: 'product_detail_add_to_cart', //事件标签名
                    ecommerce: {
                        currency: Shopify.currency.active || '',  //币种
                        items: [
                            {
                                item_id: getVariantSku(document.querySelector('input[name="id"]')?.value),   // 传入商品sku
                                item_name: document.querySelector('.product__title').innerText.trim(), // 传入商品标题
                                price: parseFloat(document.querySelector('[data-product-price]')?.innerText.replace(/[^\d.]/g, '')) || -1,  // 传入商品价格
                                item_variant: [...document.querySelectorAll('[data-product-variants] .radio__button.is-active .option-title')].map(el => el.innerText).join(', '), //加购的属性值，多个属性使用逗号分隔
                                quantity: document.querySelector('[name="quantity"]')?.value || 0, //传入加购数量
                                item_category: document.querySelector('[data-product-category]')?.dataset.productCategory || '' //产品一级类目名,
                            }
                        ]
                    },
                    add_to_cart_source: "product_detail", //默认为product_detail
                    is_played_video: hasProductVideoPlayed() ? '1' : '0'
                };
                pushCfg = { ...baseCfg, ...overlayCfg };
                pushCfg.position = 'middle';
            }
            //点击快捷支付按钮
            else if (gaTarget = evtTarget.matches(addToCartPopupBtnSelector) ? evtTarget : evtTarget.closest(addToCartPopupBtnSelector)) {
                const overlayCfg = {
                    event: "customer_add_to_cart", // 事件名称
                    page_type: "product_detail",
                    event_label: 'product_detail_add_to_cart', //事件标签名
                    ecommerce: {
                        currency: Shopify.currency.active || '',  //币种
                        items: [
                            {
                                item_id: getVariantSku(document.querySelector('input[name="id"]')?.value),   // 传入商品sku
                                item_name: document.querySelector('.product__title').innerText.trim(), // 传入商品标题
                                price: parseFloat(document.querySelector('[data-product-price]')?.innerText.replace(/[^\d.]/g, '')) || -1,  // 传入商品价格
                                item_variant: [...document.querySelectorAll('[data-product-variants] .radio__button.is-active .option-title')].map(el => el.innerText).join(', '), //加购的属性值，多个属性使用逗号分隔
                                quantity: document.querySelector('[name="quantity"]')?.value || 0, //传入加购数量
                                item_category: document.querySelector('[data-product-category]')?.dataset.productCategory || '' //产品一级类目名,
                            }
                        ]
                    },
                    add_to_cart_source: "product_detail", //默认为product_detail
                    is_played_video: hasProductVideoPlayed() ? '1' : '0'
                };
                pushCfg = { ...baseCfg, ...overlayCfg };
                pushCfg.position = 'bottom';
            }

            if (gaTarget) {
                dataLayer.push(pushCfg);
            }
        });
    }

    if (location.pathname.indexOf("/cart") === 0) {
        const cartForm = document.querySelector('#cartForm');
        cartForm?.addEventListener('click', async function (evt) {
            const evtTarget = evt.target;
            const checkoutBtnSelector = 'button[name="checkout"]';
            const dynamicCheckoutBtnSelector = getAcceleratedCheckoutSelectors();
            let gaTarget, pushCfg;

            //点击checkout按钮
            if (gaTarget = evtTarget.matches(checkoutBtnSelector) ? evtTarget : evtTarget.closest(checkoutBtnSelector)) {
                const { page_path, ...restCfg } = baseCfg;
                const cart = await getCartJson();
                const overlayCfg = {
                    event: "customer_checkout",
                    page_type: "cart",
                    event_label: 'cart_checkout_from_cart',
                    ecommerce: {
                        currency: Shopify.currency.active || cart?.currency || '',
                        value: cart ? cart.total_price / 100 : '',
                        items: cart ? cart.items.map(item => ({
                            item_id: item.sku || item.variant_id.toString(),
                            item_name: item.title,
                            price: item.price / 100,
                            item_variant: item.variant_title || '',
                            quantity: item.quantity,
                            item_category: item.product_type || ''
                        })) : []
                    },
                    checkout_method: 'checkout_page',
                    payment_source: 'cart'
                };
                pushCfg = { ...restCfg, ...overlayCfg };
            }
            //点击快捷支付按钮
            else if (gaTarget = evtTarget.matches(dynamicCheckoutBtnSelector) ? evtTarget : evtTarget.closest(dynamicCheckoutBtnSelector)) {
                const { page_path, ...restCfg } = baseCfg;
                const cart = await getCartJson();
                const overlayCfg = {
                    event: 'customer_quick_pay_from_cart',
                    page_type: 'cart',
                    event_label: 'cart_quick_pay',
                    ecommerce: {
                        currency: Shopify.currency.active || cart?.currency || '',
                        value: cart ? cart.total_price / 100 : '',
                        items: cart ? cart.items.map(item => ({
                            item_id: item.sku || item.variant_id.toString(),
                            item_name: item.title,
                            price: item.price / 100,
                            item_variant: item.variant_title || '',
                            quantity: item.quantity,
                            item_category: item.product_type || ''
                        })) : []
                    },
                    checkout_method: getAcceleratedCheckoutMethod(evtTarget),
                    payment_source: 'cart',
                }
                pushCfg = { ...restCfg, ...overlayCfg };
            }

            if (gaTarget) {
                dataLayer.push(pushCfg);
            }
        });
    }
})(window);
